import { consentElementsToChoiceQuestions, consentElementsToDateFields, consentElementsToTextFields, } from 'libs.consent.common';
import { consentElementsToSignatureFields } from './consent_template_bundler';
/**
 * Read-only markers for the Studio "View source" PDF. Geometry matches the compiled
 * `form.json` overlays (CSS percentages). Captions name the overlay kind and signer role;
 * this preview is not the signing bundle and does not collect values.
 */
export function consentElementsToPreviewOverlays(elements, roles = []) {
    const placed = elements.filter((element) => element.config.ec__key?.trim());
    const placedChoiceKeys = new Set(placed.flatMap((el) => (el.config.ec__options ?? []).filter((opt) => opt.placed).map((opt) => `${el.config.ec__key}:${opt.key}`)));
    const signatures = consentElementsToSignatureFields(placed, roles).map((field) => ({
        id: `signature-${field.ec__key}`,
        page: field.page ?? 1,
        xPct: field.xPct,
        yPct: field.yPct,
        widthPct: field.widthPct,
        heightPct: field.heightPct,
        caption: `${field.type} (${field.role})`,
        kind: field.type,
        role: field.role,
    }));
    const dates = consentElementsToDateFields(placed, roles).map((field) => ({
        id: `date-${field.ec__key}`,
        page: field.page,
        xPct: field.xPct,
        yPct: field.yPct,
        widthPct: field.widthPct,
        heightPct: field.heightPct,
        caption: `DATE (${field.role})`,
        kind: 'DATE',
        role: field.role,
    }));
    const texts = consentElementsToTextFields(placed, roles).map((field) => ({
        id: `text-${field.ec__key}`,
        page: field.page,
        xPct: field.xPct,
        yPct: field.yPct,
        widthPct: field.widthPct,
        heightPct: field.heightPct,
        caption: `${field.inputType === 'ec__numeric' ? 'NUMERIC' : field.inputType === 'ec__email' ? 'EMAIL' : 'TEXT'} (${field.role})`,
        kind: field.inputType === 'ec__numeric' ? 'NUMERIC' : field.inputType === 'ec__email' ? 'EMAIL' : 'TEXT',
        role: field.role,
    }));
    const choices = consentElementsToChoiceQuestions(placed, roles).flatMap((question) => question.choices
        .filter((choice) => placedChoiceKeys.has(`${question.ec__key}:${choice.optionKey}`))
        .map((choice) => ({
        id: `choice-${question.ec__key}-${choice.optionKey}`,
        page: choice.page,
        xPct: choice.xPct,
        yPct: choice.yPct,
        widthPct: choice.widthPct,
        heightPct: choice.heightPct,
        caption: `${question.isMultiSelect ? 'CHECKBOX' : 'SINGLE SELECT'} (${question.role})`,
        kind: question.isMultiSelect ? 'CHECKBOX' : 'SINGLE SELECT',
        role: question.role,
    })));
    return [...signatures, ...dates, ...texts, ...choices];
}
